import { createApp } from 'vue'
import PixelsToInches from './PixelsToInches.vue'
import './assets/global.css'

createApp(PixelsToInches).mount('#pixels-to-inches')
